document.querySelectorAll('[data-logo-purchase-card]').forEach((card) => {
  const purchaseUrl = card.dataset.purchaseUrl;
  if (!purchaseUrl) return;

  card.addEventListener('click', (event) => {
    if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    if (event.target.closest('.laia-logo-card__purchase-button')) return;

    if (!card.classList.contains('is-tapped')) {
      event.preventDefault();
      document.querySelectorAll('[data-logo-purchase-card].is-tapped').forEach((openCard) => {
        if (openCard !== card) openCard.classList.remove('is-tapped');
      });
      card.classList.add('is-tapped');
      return;
    }

    window.location.assign(purchaseUrl);
  });

  card.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    event.preventDefault();
    if (card.classList.contains('is-tapped')) {
      window.location.assign(purchaseUrl);
    } else {
      card.classList.add('is-tapped');
    }
  });
});

document.querySelectorAll('.laia-logo-card').forEach((card) => {
  if (card.matches('[data-logo-purchase-card]')) return;
  if (!card.querySelector('.laia-logo-card__name')) return;

  card.addEventListener('click', (event) => {
    if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    if (card.classList.contains('is-name-tapped')) return;

    event.preventDefault();
    document.querySelectorAll('.laia-logo-card.is-name-tapped').forEach((openCard) => {
      if (openCard !== card) openCard.classList.remove('is-name-tapped');
    });
    card.classList.add('is-name-tapped');
  });
});

document.addEventListener('click', (event) => {
  if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
  if (event.target.closest('.laia-logo-card')) return;
  document.querySelectorAll('.laia-logo-card.is-name-tapped').forEach((card) => {
    card.classList.remove('is-name-tapped');
  });
});

